// extracted by mini-css-extract-plugin
export default {"button":"MotionButton_button__SwLW1","button--primary":"MotionButton_button--primary__i151a","button--secondary":"MotionButton_button--secondary__kmZ1r"};